var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pimport" },
    [
      _c(_setup.multiselect, {
        staticClass: "pimport__multi",
        attrs: {
          label: "name",
          "track-by": "sid",
          placeholder: "Введите фамилию туриста или номер заявки",
          options: _setup.found,
          multiple: false,
          searchable: true,
          loading: _setup.isLoading,
          "close-on-select": true,
          "clear-on-select": false,
          "internal-search": false,
          "options-limit": 300,
          "show-no-results": true,
          "hide-selected": true,
          preserveSearch: true,
          showNoOptions: false,
          "group-values": "tourists",
          "group-label": "name",
          "group-select": false,
          selectLabel: "Выбрать",
          selectGroupLabel: "Выбрать",
          selectedLabel: "Выбрано",
          deselectLabel: "Убрать",
          deselectGroupLabel: "Убрать",
        },
        on: { "search-change": _setup.asyncFind },
        scopedSlots: _vm._u([
          {
            key: "noResult",
            fn: function ({ search }) {
              return [
                _c("span", { staticClass: "pimport__person error" }, [
                  _setup.findErr.is
                    ? _c("span", [
                        _setup.findErr.needAuth
                          ? _c("span", [
                              _vm._v("Выполните вход в Кабинет Агента"),
                            ])
                          : _c("span", [
                              _vm._v(
                                "Поиск не выполнен: " +
                                  _vm._s(_setup.findErr.message)
                              ),
                            ]),
                      ])
                    : _c("span", [
                        _vm._v('"' + _vm._s(search) + '" - не найдено'),
                      ]),
                ]),
              ]
            },
          },
          {
            key: "option",
            fn: function ({ option, search, index }) {
              return [
                option["$isLabel"]
                  ? _c("span", { staticClass: "pimport__group" }, [
                      _c("b", [_vm._v(_vm._s(option.$groupLabel.num) + ":")]),
                      _vm._v(
                        "\n                " +
                          _vm._s(option.$groupLabel.tour) +
                          "\n                " +
                          _vm._s(
                            _setup
                              .dayjs(option.$groupLabel.dateFrom)
                              .format("DD.MM.YYYY")
                          ) +
                          "\n                " +
                          _vm._s(option.$groupLabel.town) +
                          "\n            "
                      ),
                    ])
                  : _c(
                      "span",
                      { staticClass: "pimport__person" },
                      [
                        !option.isCust
                          ? [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(option.lastName) +
                                  " " +
                                  _vm._s(option.firstName) +
                                  " " +
                                  _vm._s(option.middleName) +
                                  ",\n                    " +
                                  _vm._s(_setup.age(option)) +
                                  ", \n                    "
                              ),
                              _c("div", [_vm._v(_vm._s(_setup.doc(option)))]),
                            ]
                          : [
                              _vm._v(
                                "\n                    заказчик:\n                    " +
                                  _vm._s(option.lastName) +
                                  " " +
                                  _vm._s(option.firstName) +
                                  " " +
                                  _vm._s(option.middleName) +
                                  "\n                "
                              ),
                            ],
                      ],
                      2
                    ),
              ]
            },
          },
        ]),
        model: {
          value: _setup.source_person,
          callback: function ($$v) {
            _setup.source_person = $$v
          },
          expression: "source_person",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "custom-field" }, [
        _c(
          "button",
          {
            staticClass: "btn btn--blue custom-field__but",
            attrs: { disabled: !_setup.source_person },
            on: { click: _setup.copy_person_do },
          },
          [_vm._v("Внести данные")]
        ),
        _vm._v(" "),
        _c("br"),
        _vm._v("Все ранее введенные поля очистятся\n    "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }